import { render, staticRenderFns } from "./BracketFigtSection.vue?vue&type=template&id=4e64d578&"
import script from "./BracketFigtSection.vue?vue&type=script&lang=js&"
export * from "./BracketFigtSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports